import type CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import {
    type UTCalendarFolderType,
    type UTCalendarMailboxProvider,
    type UTCalendarViewType,
} from 'owa-unified-telemetry';
import { type MailboxProvider } from 'owa-client-types';
import { DateRangeType } from '@fluentui/date-time-utilities';

export const calendarFolderTypeMap: {
    [key: number]: UTCalendarFolderType;
} = {
    [0]: 'Other',
    [1]: 'Primary',
    [2]: 'Other',
    [3]: 'Birthday',
    [4]: 'Holiday',
    [5]: 'PublicFolder',
    [6]: 'Other',
    [7]: 'Other',
};

// When MailboxProvider is Unknown, we won't log this field
export const calendarMailboxProviderMap: {
    [key in MailboxProvider]: UTCalendarMailboxProvider | undefined;
} = {
    Office365: 'Office365',
    Outlook: 'Outlook',
    Google: 'Google',
    Yahoo: 'Other',
    ICloud: 'Other',
    IMAP: 'Other',
    POP3: 'Other',
    PstFile: 'Other',
    MessageFile: 'Other',
    Unknown: undefined,
};

export const calendarDateRangeTypeMap: {
    [key: number]: UTCalendarViewType;
} = {
    [DateRangeType.Day]: 'Day',
    [DateRangeType.Week]: 'Week',
    [DateRangeType.WorkWeek]: 'WorkWeek',
    [DateRangeType.Month]: 'Month',
};
